export class DateTimeUtils {
  convertDate(dateTime) {
    let month = `${dateTime.getMonth() + 1}`;
    let day = `${dateTime.getDate()}`;
    const year = dateTime.getFullYear();
    if (month.length < 2) month = `0${month}`;
    if (day.length < 2) day = `0${day}`;
    const dateString = [day, month, year].join('.');
    return dateString;
  }

  convertTime(dateTime) {
    let hour = `${dateTime.getHours()}`;
    let min = `${dateTime.getMinutes()}`;
    if (hour.length < 2) { hour = `0${hour}`; }
    if (min.length < 2) { min = `0${min}`; }
    const timeString = [hour, min, '00'].join(':');
    return timeString;
  }
}
